// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpacesList__container-be5bab {
  flex: 1;
}

.SpacesList__recommended-title-c6928f {
  font: var(--font-button);
  letter-spacing: var(--font-spacing-button);
  color: var(--base-70);
  padding: 16px 16px 0;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SpacesList/SpacesList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,oBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n}\n\n.recommended-title {\n  font: var(--font-button);\n  letter-spacing: var(--font-spacing-button);\n  color: var(--base-70);\n  padding: 16px 16px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SpacesList__container-be5bab`,
	"recommended-title": `SpacesList__recommended-title-c6928f`,
	"recommendedTitle": `SpacesList__recommended-title-c6928f`
};
module.exports = ___CSS_LOADER_EXPORT___;
